const Card = {
  baseStyle: {
    p: "22px",
    display: "flex",
    flexDirection: "column",
    backdropFilter: "blur(120px)",
    width: "100%",
    borderRadius: "10px",
    backgroundColor: "#e3e2e2",
    border: "1px solid gray",
    backgroundClip: "border-box",
  },
};

export const CardComponent = {
  components: {
    Card,
  },
};
